<template>
  <layout-content :total="total">
    <!-- 面包屑的插槽 -->
    <breadcrumb slot="breadcrumb"></breadcrumb>
    <div slot="content">
      <!-- 搜索和新增删除 -->
      <div class="d-f a-c j-b">
        <a-form-model ref="queryForm" :model="queryParams" layout="inline">
          <a-form-model-item label="设备类型名称" prop="deviceTypeName">
            <a-input
              v-model="queryParams.deviceTypeName"
              placeholder="请输入设备类型名称"
              allowClear
              @keyup.enter.native="handleQuery"
            />
          </a-form-model-item>
          <a-form-model-item label="设备类型标识" prop="deviceTypeIdentification">
            <a-input
              v-model="queryParams.deviceTypeIdentification"
              placeholder="请输入设备类型标识"
              allowClear
              @keyup.enter.native="handleQuery"
            />
          </a-form-model-item>
          <a-form-model-item>
            <a-button
              type="primary"
              @click="handleQuery"
              v-hasPermi="['device:type:query']"
              >搜索</a-button
            >
            <a-button @click="resetQuery" class="ml10" v-hasPermi="['device:type:query']"
              >重置</a-button
            >
          </a-form-model-item>
        </a-form-model>
        <div>
          <a-button
            type="primary"
            @click="handleAdd"
            icon="plus"
            v-hasPermi="['device:type:add']"
            >新增</a-button
          >
          <a-button @click="refreshCache" class="ml10" v-hasPermi="['device:type:query']"
            >刷新缓存</a-button
          >
        </div>
      </div>
      <!--表格-->
      <a-table
        :columns="columns"
        rowKey="id"
        :data-source="data"
        :pagination="false"
        class="mt20"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleUpdate(record)" v-hasPermi="['device:type:edit']">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['device:type:remove']">删除</a>
        </span>
      </a-table>
      <!--分页-->
      <div class="d-f mt20">
        <a-pagination
          v-model="queryParams.page"
          :pageSize="queryParams.limit"
          :default-current="1"
          :total="total"
          :hideOnSinglePage="true"
          showLessItems
          @change="onChange"
          :item-render="itemRender"
          style="margin-left: auto"
        />
      </div>
      <!--新增和编辑的弹出框-->
      <a-modal
        v-model="visible"
        :title="title"
        @ok="submit"
        @cancel="handleCancel"
        width="500px"
      >
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="设备类型名称" prop="deviceTypeName">
                <a-input v-model="form.deviceTypeName" placeholder="请输入设备类型名称" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="设备类型标识" prop="deviceTypeIdentification">
                <a-input
                  v-model="form.deviceTypeIdentification"
                  placeholder="请输入设备类型标识"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="设备通信方式" prop="deviceTransportProtocol">
                <a-select
                  v-model="form.deviceTransportProtocol"
                  placeholder="请选择设备通信方式"
                  style="width: 100%"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    v-for="item in communicationList"
                    :key="item.protocolIdentification"
                    :value="item.protocolIdentification"
                  >
                    {{ item.protocolName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="显示排序" prop="orderNum">
                <a-input-number
                  v-model="form.orderNum"
                  placeholder="请输入显示排序"
                  :min="1"
                  style="width: 100%"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-modal>
    </div>
  </layout-content>
</template>

<script>
import LayoutContent from "@/views/layout/content";
import Breadcrumb from "~c/Breadcrumb";
import { getCommunicationList } from "@/api/device/communication.js";
import {
  getTypeList,
  typeAddOrUpdate,
  typeRemove,
  getType,
  refreshCache,
} from "@/api/device/type.js";
const columns = [
  {
    title: "设备类型名称",
    dataIndex: "deviceTypeName",
    align: "center",
  },
  {
    title: "设备类型标识",
    dataIndex: "deviceTypeIdentification",
    align: "center",
  },
  {
    title: "设备通信方式",
    dataIndex: "deviceTransportProtocol",
    align: "center",
  },
  {
    title: "显示排序",
    dataIndex: "orderNum",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "action",
    align: "center",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  name: "Type",
  components: { LayoutContent, Breadcrumb },
  data() {
    return {
      total: null,
      // 查询参数
      queryParams: {
        //当前页
        page: 1,
        //一页几个
        limit: 10,
      },
      //表格的表头文字
      columns,
      //表格的数据
      data: [],
      //新增和编辑的表单
      form: {},
      //表单规则
      rules: {
        deviceTypeName: [
          {
            required: true,
            message: "请输入设备类型名称",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        deviceTypeIdentification: [
          {
            required: true,
            message: "请输入设备类型标识",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        deviceTransportProtocol: [
          {
            required: true,
            message: "请选择设备通信方式",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        orderNum: [
          {
            type: "number",
            required: true,
            message: "请输入显示排序",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
      },
      //label和wrapper的占位
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      //新增和编辑弹出框的标题
      title: "",
      //新增和编辑弹出框的显示隐藏
      visible: false,
      //设备通信方式列表
      communicationList: [],
    };
  },
  methods: {
    //获取通信列表
    getTypeList() {
      getTypeList(this.queryParams).then((res) => {
        this.data = res.data;
        this.total = res.count;
      });
    },
    //搜索
    handleQuery() {
      this.queryParams.page = 1;
      this.getTypeList();
    },
    //搜索重置
    resetQuery() {
      this.queryParams.page = 1;
      this.$refs.queryForm.resetFields();
      this.getTypeList();
    },
    //刷新缓存
    refreshCache() {
      refreshCache().then((res) => {
        this.$message.success("刷新成功");
      });
    },
    /** 新增按钮操作 */
    handleAdd() {
      getCommunicationList({ isPage: false }).then((res) => {
        this.communicationList = res.data;
        this.form = {};
        this.visible = true;
        this.title = "新增设备类型";
      });
    },
    /** 修改按钮操作 */
    async handleUpdate(row) {
      this.form = {};
      let result = await getCommunicationList({ isPage: false });
      this.communicationList = result.data;
      let res = await getType(row.id);
      this.form = res.data;
      this.visible = true;
      this.title = "修改设备类型";
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm({
        title: "您确认删除您选中的数据吗？",
        onOk: () => {
          typeRemove(row.id).then((res) => {
            this.$message.success("删除成功");
            this.getTypeList();
          });
        },
      });
    },
    //新增或编辑确定
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          typeAddOrUpdate(this.form).then((res) => {
            //修改
            if (this.form.id) {
              this.$message.success("修改成功");
            }
            //新增
            else {
              this.$message.success("新增成功");
            }
            this.visible = false;
            this.getTypeList();
          });
        }
      });
    },
    //新增或编辑取消
    handleCancel() {
      this.$refs.ruleForm.resetFields();
      this.visible = false;
    },
    //分页状态改变
    onChange(pageNumber) {
      this.queryParams.page = pageNumber;
      this.getTypeList();
    },
    //改变分页上一步下一步的文字链接
    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return <a>上一页</a>;
      } else if (type === "next") {
        return <a class="next">下一页</a>;
      }
      return originalElement;
    },
  },
  created() {
    this.getTypeList();
  },
};
</script>

<style scoped lang="less"></style>
